import { Toaster } from "components/notification/Toaster";
import { useDispatch } from "react-redux";
import usePromiseInstance_authorization from "./config";
import { func_serviceHandling, isNumberOrStringValid, isNumberValid } from "functions";
import { 
    getDebitNoteList_request,
    getDebitNoteList_success,
    getDebitNoteList_failure,
    deleteDebitNote_request,
    deleteDebitNote_success,
    deleteDebitNote_failure
 } from "../slices/debitNoteV2.slices";

export default function useDebitNoteV2() {
    const dispatch = useDispatch();
    const request = usePromiseInstance_authorization();

    function getDebitNoteList(pageNo, pageSize, sort, filterOptions = {}) {

        let isOffsetValid = isNumberValid(pageNo) && isNumberValid(pageSize);
        let offset = isOffsetValid? pageNo * pageSize:0;
    
        let paramObj = {
            offset: offset,
            limit: pageSize,
            sort: sort,
            ...filterOptions
        }

        let url = func_serviceHandling.createUrlWithParams('/Invoice/SearchDebitNoteV2', paramObj)

        dispatch(getDebitNoteList_request());

        request(getDebitNoteList_request, (axios) => {    
            axios.get(url)
                .then((response) => {
                    dispatch(getDebitNoteList_success(response));
                })
                .catch((error) => {
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to load Debit Note(s)";
					Toaster({ type: "error", msg });

                    dispatch(getDebitNoteList_failure(msg));
                })
        })
    }

    function deleteDebitNote(id) {

        let id_formatted = "";
		if (isNumberOrStringValid(id))
			id_formatted = encodeURI(id);

        dispatch(deleteDebitNote_request());

        request(deleteDebitNote_request, (axios) => {    
            axios.delete('/Invoice/DeleteDebitNote/' + id_formatted)
                .then((response) => {
                    dispatch(deleteDebitNote_success(response));
                })
                .catch((error) => {
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to delete Debit Note(s)";
					Toaster({ type: "error", msg });

                    dispatch(deleteDebitNote_failure(msg));
                })
        })
    }

    return {
        getDebitNoteList,
        deleteDebitNote
    }
}